import React, { useState } from "react";
import { Typography, TextField, Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Loader from "react-loader";

// components
import MainLayout from "../components/hoc/MainLayout";

// helpers
import validateEmail from "../helpers/validateEmail";
import { apiPost } from "../helpers/api";

const useStyles = makeStyles((theme) => ({
  form: {
    width: "100%", // Fix IE 11 issue.
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
    backgroundColor: "#A3080C",
    color: "#fff",
    "&:hover": {
      backgroundColor: "#bd0d12",
      borderColor: "#564345",
    },
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
}));

function AddRider(props) {
  const classes = useStyles();

  const valuesObject = {
    email: "",
    firstName: "",
    lastName: "",
    password: "",
  };

  const [values, setValues] = useState(valuesObject);
  const [errors, setErrors] = useState(valuesObject);
  const [loaded, setLoaded] = useState(true);

  const renderTextField = (id, label, fieldName, fieldType = "text") => {
    return (
      <TextField
        variant="outlined"
        margin="normal"
        // required
        fullWidth
        id={id}
        label={label}
        autoFocus={fieldName === "email"}
        type={fieldType}
        value={values[fieldName]}
        error={!!errors[fieldName]}
        helperText={errors[fieldName]}
        onChange={(e) =>
          setValues((prevValues) => ({
            ...prevValues,
            [fieldName]: e.target.value,
          }))
        }
      />
    );
  };

  const validateForm = () => {
    // clear errors
    setErrors(valuesObject);

    let hasErrors = false;

    // validate form
    Object.keys(values).forEach((key) => {
      // make sure everything is filled out
      if (values[key]?.trim() === "") {
        setErrors((prevErrors) => ({
          ...prevErrors,
          [key]: "This field is required.",
        }));
        hasErrors = true;
      }

      // validate email
      if (key === "email" && !validateEmail(values.email)) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          email: "Invalid email.",
        }));
        hasErrors = true;
      }
    });

    return !hasErrors;
  };

  const formHandler = async (e) => {
    e.preventDefault();
    setLoaded(false);

    if (validateForm()) {
      try {
        // send data to api endpoint
        const response = await apiPost("/admin/riders", {
          ...values,
        });

        if (response.data.data) {
          props.history.push(`/riders`);
        }
      } catch (err) {
        console.log(err.response?.data?.message);
        setLoaded(true);
      }
    } else {
      setLoaded(true);
    }
  };

  return (
    <Loader loaded={loaded}>
      <Typography variant="h5" gutterBottom>
        Add Rider
      </Typography>
      <form className={classes.form} onSubmit={formHandler}>
        {renderTextField("email", "Email", "email", "email")}
        {renderTextField("firstName", "First Name", "firstName")}
        {renderTextField("lastName", "Last Name", "lastName")}
        {renderTextField("password", "Password", "password", "password")}

        <Button
          type="submit"
          disableElevation
          variant="contained"
          fullWidth
          className={classes.submit}
        >
          Save Rider
        </Button>
      </form>
    </Loader>
  );
}

export default MainLayout(AddRider, true, true);
